import React, { useEffect } from 'react';
import WorkoutPlanCard from '../AiTrainer/WorkoutPlanCard';

export default function WorkoutPlanModal({ isOpen, onClose, plan }) {
	useEffect(() => {
		if (!isOpen) return undefined;

		function handleKeyDown(event) {
			if (event.key === 'Escape') onClose();
		}

		window.addEventListener('keydown', handleKeyDown);
		return () => window.removeEventListener('keydown', handleKeyDown);
	}, [isOpen, onClose]);

	if (!isOpen || !plan) return null;

	return (
		<div
			className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 dark:bg-black/75 p-3 sm:p-4"
			onClick={onClose}
			role="presentation"
		>
			<div
				className="relative flex w-full min-w-0 max-w-2xl flex-col overflow-hidden rounded-2xl border border-gray-300 dark:border-dark-border bg-white dark:bg-dark-card shadow-xl"
				style={{ maxHeight: '90vh' }}
				onClick={(event) => event.stopPropagation()}
				role="dialog"
				aria-modal="true"
				aria-labelledby="workout-plan-modal-title"
			>
				<div className="relative shrink-0 border-b border-gray-200 dark:border-dark-border px-4 py-3 pr-12">
					<h3 id="workout-plan-modal-title" className="text-lg font-semibold text-gray-900 dark:text-dark-text">
						Workout plan
					</h3>
					<button
						type="button"
						onClick={onClose}
						className="absolute right-2 top-2 rounded-lg p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-dark-bg dark:hover:text-dark-text"
						aria-label="Close workout plan"
					>
						<i className="fa-solid fa-xmark" aria-hidden="true" />
					</button>
				</div>

				<div className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-4 py-4">
					<WorkoutPlanCard plan={plan} embedded />
				</div>
			</div>
		</div>
	);
}
